'use client';
import React, { useCallback } from 'react';
import Anchor from '@ui/Anchor/Anchor';
import { Button } from '@ui/Button/Button';
import useTimer from '../../../../lib/hooks/useTimer';
import { useRouter } from 'next/navigation';
import { AnalyticsEvent, sendEvent } from '../../../../utils/segment';

type TemplateSetButtonProps = {
  hash: string;
  href: string;
  text: string;
  primary?: boolean;
};

export default function TemplateSetButton({ hash, href, text, primary = false }: TemplateSetButtonProps) {
  const getTime = useTimer();
  const router = useRouter();

  const onClick = useCallback(
    () => () => {
      const secondsOnPage = Math.round(getTime() / 1000);

      sendEvent(AnalyticsEvent.SingleVsSet, {
        hash,
        isSet: true,
        secondsOnPage,
      });

      // Navigate to the URL
      router.push(href);
    },
    [getTime, hash, href, router],
  );

  return (
    <Anchor aria-label={'d'} target="_blank" onClick={onClick()}>
      <Button size="l" variant={primary ? 'primary' : 'outline'}>
        {text}
      </Button>
    </Anchor>
  );
}
